<template>
  <div class="container">
    <table class="highlight">
      <thead>
        <tr>
          <th class="color-block"></th>
          <th class="pl-4">Status</th>
          <th>Repost</th>
          <th>Title</th>
          <th>Price</th>
        </tr>
      </thead>

      <tbody>
        <dy-ad
          v-for="(ad, i) in ads"
          :key="i + ad"
          :activate="ad.toActivate"
          :adColor="getColor(ad)"
        >
          <template v-slot:status>{{ capitalize(ad.status) }}</template>
          <template v-slot:toActivate>{{ ad.toActivate }}</template>
          <template v-slot:title>{{ ad.title }}</template>
          <template v-slot:price>{{ ad.price }}</template>
        </dy-ad>
      </tbody>
    </table>
  </div>
</template>

<script>
import Ad from "./Ad.vue";

export default {
  data() {
    return {
      // ads: []
    };
  },
  props: ["ads"],
  components: {
    dyAd: Ad
  },
  methods: {
    getColor(ad) {
      if (ad.status == "expired") return "#fb8c00";
      if (ad.status == "active") return "#4caf50 ";
      if (ad.status == "deleted") return "#40c4ff";
      if (ad.status == "removed") return "#c62828";
      if (ad.status == "renew") return "#283593";
      else return "white";
    },
    capitalize(status) {
      return status[0].toUpperCase() + status.slice(1);
    }
  }
};
</script>
<style scoped>
.color-block {
  width: 5px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Table.vue